import { isLocal } from '../localId/localId';
import {
  ADD_LOCAL_PROJECT, API_CREATE_ASSIGN_PROJECT,
  API_CREATE_PROJECT,
  API_LOAD_PROJECTS, API_REMOVE_ASSIGN_PROJECT,
  API_REMOVE_PROJECT,
  API_UPDATE_PROJECT,
  REMOVE_LOCAL_PROJECT,
} from './projects.reducer';

export const load = () => ({ resourceAction: API_LOAD_PROJECTS });
export const save = resource =>
  ((isLocal(resource.id))
    ? { resourceAction: API_CREATE_PROJECT, resource }
    : { resourceAction: API_UPDATE_PROJECT, resource });
export const add = () => ({ type: ADD_LOCAL_PROJECT });
export const remove = id =>
  ((isLocal(id))
    ? { type: REMOVE_LOCAL_PROJECT, id }
    : { resourceAction: API_REMOVE_PROJECT, id });

export const assign = id => ({ resourceAction: API_CREATE_ASSIGN_PROJECT, resource: { id } });
export const unassign = id => ({ resourceAction: API_REMOVE_ASSIGN_PROJECT, id });



// WEBPACK FOOTER //
// ./src/reducers/projects/projects.actions.js